/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import styled from "styled-components";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import Button from "../Buttons/Button";
import Input from "../Input";
import { TextSubtitle, TextTitle } from "../../styles";
import loginIllustration from "../../assets/illustrations/login.svg";
import InlineLink from "../InlineLink";
import Card from "../Cards/Card";

interface ChangePassPageProps {
    handleView: React.Dispatch<React.SetStateAction<string>>;
    onChangePass: (data: { token: string; password: string }) => Promise<void>;
}

const validationSchema = yup.object({
    token: yup.string().required().max(255),
    password: yup.string().required().min(8),
});

const ChangePassPage: React.FC<ChangePassPageProps> = ({
    handleView,
    onChangePass,
    ...props
}) => (
    <Card alt="login page" imageSrc={loginIllustration}>
        <Formik
            initialValues={{ token: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                onChangePass(data);
                setSubmitting(false);
                resetForm();
            }}
        >
            {({ values, isSubmitting }) => (
                <Form>
                    <LeftContainer>
                        <TextContainer>
                            <Title>Change Password</Title>
                            <Subtitle>Reset your password</Subtitle>
                        </TextContainer>
                        <InputContainer>
                            <Field
                                name="token"
                                label="Enter Verification OTP"
                                type="text"
                                as={Input}
                            />
                            <Field
                                name="password"
                                label="Password"
                                type="password"
                                as={Input}
                            />
                        </InputContainer>
                        <ButtonContainer>
                            <Button
                                text="Reset"
                                disabled={isSubmitting}
                                type="submit"
                            />
                        </ButtonContainer>
                        <ExtraContainer>
                            {props?.enableSocialLogin ? (
                                <InlineLink
                                    text="Log in with social media?"
                                    textLink="Social log in"
                                    handleView={() => handleView("social")}
                                />
                            ) : null}
                            {props?.enableSignup ? (
                                <InlineLink
                                    text="Don't have an account?"
                                    textLink="Sign up!"
                                    handleView={() => handleView("signup")}
                                />
                            ) : null}
                        </ExtraContainer>
                    </LeftContainer>
                </Form>
            )}
        </Formik>
    </Card>
);

const LeftContainer = styled.div`
    align-content: center;
    display: grid;
    gap: 1.5em;
    grid-template-rows: repeat(3, min-content);
    height: 100%;
    width: 500px;
    @media (max-width: 1000px) {
        width: 450px;
    }

    @media (max-width: 768px) {
        width: 400px;
    }

    @media (max-width: 650px) {
        width: 300px;
    }

    @media (max-width: 450px) {
        width: 98%;
    }
`;

const TextContainer = styled.div`
    display: grid;
    gap: 0.2em;
`;

const Title = styled(TextTitle)``;

const Subtitle = styled(TextSubtitle)``;

const InputContainer = styled.div`
    display: grid;
    gap: 1em;
`;

const ButtonContainer = styled.div``;

const ExtraContainer = styled.div`
    display: grid;
    gap: 0.5em;
    grid-template-rows: repeat(2, min-content);
`;

export default ChangePassPage;
